import Contacts from "@/services/contacts.js";

const state = {
    selected: null,
    isCompany: false,
    contactDetails: {},
    contactEditDetails: {},
    contactId: null,
    editMode: false,
    isValidated: true
};

const getters = {
    contactDetails: state => {
        return state.contactDetails;
    },
    contactEditDetails: state => {
        return state.contactEditDetails;
    },
    selected: state => {
        return state.selected;
    },
    isCompany: state => {
        return state.isCompany;
    },
    isValidated: state => {
        return state.isValidated;
    }
};

const actions = {
    async getContactActorDetails({ commit }, payload) {
        let params = {
            encoded: payload.encoded === false ? false : true
        };

        return Contacts.getContactActor(payload.id, params)
            .then(response => {
                if (response.message && response.message.code === 200) {
                    commit("setSelected", response.resource);
                    commit("setIsCompany", false);
                    commit("setContactDetails", response.resource);
                    commit("setContactId", response.resource.id);
                    commit(
                        "setContactEditDetails",
                        _.cloneDeep(response.resource)
                    );
                }

                return response;
            })
            .catch(error => error.data);
    },
    async getContactCompanyDetails({ commit }, payload) {
        let params = {
            encoded: payload.encoded === false ? false : true
        };

        return Contacts.getContactCompany(payload.id, params)
            .then(response => {
                if (response.message && response.message.code === 200) {
                    commit("setSelected", response.resource);
                    commit("setIsCompany", true);
                    commit("setContactDetails", response.resource);
                    commit("setContactId", response.resource.id);
                    commit(
                        "setContactEditDetails",
                        _.cloneDeep(response.resource)
                    );
                }

                return response;
            })
            .catch(error => error.data);
    }
};

const mutations = {
    setSelected(state, selected) {
        state.selected = selected;
    },
    unSetSelected(state) {
        state.selected = null;
        state.isCompany = false;
    },
    setIsCompany(state, isCompany) {
        state.isCompany = isCompany;
    },
    setContactDetails(state, contactDetails) {
        state.contactDetails = contactDetails;
    },
    setContactEditDetails(state, contactDetails) {
        state.contactEditDetails = contactDetails;
    },
    setContactId(state, contactId) {
        state.contactId = contactId;
    },
    setEditMode(state, editMode) {
        state.editMode = editMode;
    },
    setIsValidated(state, isValidated) {
        state.isValidated = isValidated;
    },
    setContactDetailPhoneNumber(state, mobileNumberObject) {
        state.contactDetails.mobile = mobileNumberObject.mobileNumber;
        state.contactDetails.mobile_country_code =
            mobileNumberObject.mobileCountryCode;
        state.contactEditDetails.mobile = mobileNumberObject.mobileNumber;
        state.contactEditDetails.mobile_country_code =
            mobileNumberObject.mobileCountryCode;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
